import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserFamilyDonations } from "../../service/UserApi";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../components/shared";

const DonationDetails = () => {
  const user = useSelector((state) => state.user);
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDonations = async () => {
      if (!user.email) return;
      if (!user.otpValidatedSession) {
        navigate(`/user/validate-session-otp?from=donation`);
        return;
      }
      setLoading(true);

      try {
        const response = await getUserFamilyDonations(user.email);
        if (response?.otpValidatedSession === false) {
          navigate(`/user/validate-session-otp?from=donation`);
        }
        setDonations(response?.donations || []);
      } catch (error) {
        console.error("Error fetching donations:", error);
        setDonations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDonations();
  }, [user.email]);

  // ✅ Simple local spinner
  const Spinner = () => (
    <div style={{ textAlign: "center", padding: "20px", fontSize: "18px" }}>
      🔄 தரவு ஏற்றப்படுகிறது...
      <Loading />
    </div>
  );

  if (loading) return <Spinner />;
  if (!donations.length) return <p>நன்கொடை விவரங்கள் இல்லை</p>;

  // ✅ Group donations by category
  const grouped = donations.reduce((acc, donation) => {
    const cat = donation.category || "மற்றவை";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(donation);
    return acc;
  }, {});

  // ✅ Sort categories by latest transaction date
  const sortedCategories = Object.entries(grouped).sort(([, a], [, b]) => {
    const latestA = Math.max(...a.map(d => d.transactionDate?._seconds || 0));
    const latestB = Math.max(...b.map(d => d.transactionDate?._seconds || 0));
    return latestB - latestA; // descending (latest first)
  });

  return (
    <>
      <br />
      <h4>நன்கொடை விவரங்கள்</h4>
      <br />

      {sortedCategories.map(([category, catDonations]) => (
        <div key={category} className="table-container">
          <table className="table" aria-label={`${category} நன்கொடைகள்`}>
            <thead>
              <tr>
                <th>{category}</th>
                <th>விவரங்கள்</th>
              </tr>
            </thead>
            <tbody>
              {catDonations
                .sort((a, b) => b.transactionDate._seconds - a.transactionDate._seconds) // latest first in each table
                .map((d, index) => (
                  <tr key={index}>
                    <td>
                      {d.category} - {d.subcategory}
                    </td>
                    <td>
                      {d.familyMemberFirstName && (
                        <span>👤 {d.familyMemberFirstName} {d.familyMemberLastName || ""} </span>
                      )}
                      {d.transactionDate
                        ? ' 📅 ' + new Date(d.transactionDate._seconds * 1000).toLocaleDateString()
                        : ""}

                      {d.receiptNo && <span> 🧾 ரசீது எண்: {d.receiptNo}</span>}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ))}
    </>
  );
};

export default DonationDetails;
